export default (context) => {
  let columns = [
    {
      Header: "ID",
      accessor: "ID",
      minWidth: 50
    },
    {
      Header: "User",
      accessor: "user",
      minWidth: 120
    },
    {
      Header: "Date Completed",
      accessor: "dateCompleted",
      isDate: true
    },
    {
      Header: "",
      accessor: "col1",
    },
    {
      Header: "",
      accessor: "col2"
    },
    {
      Header: "",
      accessor: "col3"
    },
    {
      Header: "",
      accessor: "col4"
    },
    {
      Header: "",
      accessor: "col5"
    },
    {
      Header: "",
      accessor: "col6"
    },
    {
      Header: "",
      accessor: "col7"
    },
    {
      Header: "",
      accessor: "col8"
    },
    {
      Header: "",
      accessor: "col9"
    },
    {
      Header: "",
      accessor: "col10"
    }
  ];

  return {
    config: {
      resource: "admFetchResponses",
      pageSize: 40,
      list: false,
      remap: (r) => {
        // hack for dynamic column names
        if (r.data.Results.length > 0 && r.data.Results[0].ID === -1) {
          // Use the first item to apply column names if needed
          const columnsData = r.data.Results[0]; // Get column names from the first item
          // const columnNames = Object.keys(columnsData); // Get column names from the first item
          // Exclude the first items
          r.data.Results = r.data.Results.slice(1);

          const columns = context.state.columns
          let remove = [];

          columns.map((item) => {
            if (item.accessor && item.accessor.startsWith("col")) {
              item.Header = columnsData[item.accessor];
              if (item.Header === '') remove.push(item.accessor);
            }
            return item
          })

          for (let i = columns.length - 1; i >= 0; i--) {
            if (remove.includes(columns[i].accessor)) {
              columns.splice(i, 1); // Remove the item at index i
            }
          }

          context.setState({ columns: columns });

        }
        return r
      }
    },

    actions: {
      create: false,
      edit: false,
      delete: true,
      print: { remap: true },
      export: { remap: true },
      search: true
    },

    filter: {
      fields: [
        {
          type: "daterange",
          range: {
            value: 0
          }
        },
        {
          name: "fetchId",
          value: 0,
          type: "select",
          label: 'admFlow.typeOfFetch',
          opts: {
            style: 'float-label',
            searchOnline: false,
            path: "/admFetch/get",
            withImg: false
          }
        },
        {
          name: "fetchInputId",
          value: 0,
          type: "select",
          label: "Search by input",
          parent: "fetchId",
          opts: {
            style: 'float-label',
            searchOnline: false,
            path: () => { return '/admFetchInput/get?fetchId=' + context.state.formFilter.fetchId },
            withImg: false
          },
          renderIf: (ctx) => ctx.state.fetchId > 0
        },
        {
          name: "userId",
          value: "",
          type: "select",
          label: "Customer",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStaff/get",
            withImg: true
          }
        },

        /* {
           name: "status",
           value: "",
           type: "select",
           label: "Estado",
           opts: {
             style: 'float-label',
             items: [
               {
                 value: 1,
                 label: "Confirmados"
               },
               {
                 value: 0,
                 label: "Pendientes"
               }
             ]
           }
         }*/
      ],
      buttons: [
        {
          label: 'Filter',
          renderIf: (ctx) => { return ctx.state.fetchId > 0 && (ctx.state.from || ctx.state.to || Number.isInteger(ctx.state.userId)) },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    columns: columns
  }
}